/** @file Frame of every rig panel: refusal alert, warnings of the last batch, empty state, then the body. */
import type { ReactNode } from 'react';
import { errorText } from '../../shell/i18n/errorText';
import { Button } from '../../ui-kit/Button';
import type { RigView } from './rigView';
import type { RigPanelState } from './useRigPanel';
import './rigPanel.css';

/** Props of RigPanelFrame; `testId` lands on the root for e2e checks. */
export interface RigPanelFrameProps {
  state: RigPanelState;
  testId: string;
  render: (view: RigView) => ReactNode;
}

/** At most five warnings are listed (server English text is data, not a UI string); the body renders only with a project. */
export function RigPanelFrame({ state, testId, render }: RigPanelFrameProps) {
  const { t, view, failure, notes, dismiss } = state;
  const shown = failure !== null || notes.length > 0;
  return (
    <div className="rig-panel" data-testid={testId}>
      {failure !== null && <p role="alert" className="rig-alert">{errorText(t, failure.thrown)}</p>}
      {notes.length > 0 && <ul className="rig-notes">{notes.slice(0, 5).map((w, i) => <li key={i}>{w.message}</li>)}</ul>}
      {shown && <Button label={t('panels.rig.dismiss')} onClick={dismiss} />}
      {view === null ? <p className="rig-hint">{t('panels.rig.noProject')}</p> : render(view)}
    </div>
  );
}
